export const TAG_MIDDLE_NAME = "2d";
export const TWO_PI = 2 * Math.PI;
